	<div class="card admin-tooling-card" *ngIf="tabGroups$ | async as tabGroups">
		<div class="card-body" *ngIf="{ selectedTabId: selectedTabId$ | async } as state">
			<div class="admin-tooling-layout" [class.admin-tooling-layout--collapsed]="navCollapsed">
				<nav class="admin-tooling-nav" [class.admin-tooling-nav--collapsed]="navCollapsed" aria-label="Admin tooling sections">
					<div class="admin-tooling-nav__toolbar">
						<div class="admin-tooling-nav__heading" *ngIf="!navCollapsed">Admin tooling</div>
						<button
							type="button"
							class="admin-tooling-nav__toggle"
							(click)="toggleNav()"
							[attr.aria-expanded]="!navCollapsed"
							[attr.aria-label]="navCollapsed ? 'Expand admin tooling navigation' : 'Collapse admin tooling navigation'"
							[title]="navCollapsed ? 'Expand navigation' : 'Collapse navigation'">
							<i class="far" [class.fa-chevron-right]="navCollapsed" [class.fa-chevron-left]="!navCollapsed"></i>
						</button>
					</div>
					<section class="admin-tooling-nav__group" *ngFor="let group of tabGroups">
						<div class="admin-tooling-nav__group-title">{{ group.title }}</div>
						<button
							type="button"
							class="admin-tooling-nav__item"
							*ngFor="let tab of group.tabs"
							[class.admin-tooling-nav__item--selected]="state.selectedTabId === tab.id"
							[attr.title]="navCollapsed ? tab.text : null"
							(click)="onTabClick(tab)">
							<i [class]="tab.icon"></i>
							<span>{{ tab.text }}</span>
						</button>
					</section>
				</nav>

				<div class="admin-tooling-content">
					<div class="admin-tooling-empty-state" *ngIf="!state.selectedTabId">
						<div class="admin-tooling-empty-state__title">Select an admin tooling section</div>
						<div class="admin-tooling-empty-state__text">Choose a section from the navigation to open its screen.</div>
					</div>
					<router-outlet *ngIf="state.selectedTabId"></router-outlet>
				</div>
			</div>
		</div>
	</div>
